import { diaNegocio } from '@barbones/shared';
import { Link } from '@tanstack/react-router';
import { ArrowUpRight } from 'lucide-react';
import { useSesion } from '@/api/sesion';
import { EncabezadoPagina, ModuleLayout } from '@/components/layout/ModuleLayout';
import { MODULOS, tieneAlguno } from '@/components/layout/navegacion';
import { Tarjeta } from '@/components/ui/data';
import { diaLargo } from '@/lib/utils';
import { Dashboard } from './Dashboard';

function saludo(): string {
  const hora = Number(new Intl.DateTimeFormat('en-GB', { timeZone: 'America/Mexico_City', hour: '2-digit', hour12: false }).format(new Date()));
  if (hora < 12) return 'Buenos días';
  if (hora < 19) return 'Buenas tardes';
  return 'Buenas noches';
}

/** Tablero de inicio: indicadores del día (si hay permiso de reportes) y accesos a los módulos. */
export function InicioPage() {
  const { usuario } = useSesion();
  const accesos = MODULOS.filter((m) => m.id !== 'inicio' && tieneAlguno(usuario?.permisos ?? [], m.permisos));
  const hoy = diaLargo(diaNegocio(new Date()));

  return (
    <ModuleLayout titulo="Inicio">
      <EncabezadoPagina
        titulo={`${saludo()}, ${usuario?.nombre.split(' ')[0] ?? ''}`}
        descripcion={<span className="inline-block first-letter:uppercase">{hoy}</span>}
      />
      {usuario?.permisos.some((p) => p === 'reportes.dueno' || p === 'reportes.recepcion') && <Dashboard />}
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
        {accesos.map((m, i) => (
          <Link key={m.id} to={m.to} className="group" style={{ animationDelay: `${i * 40}ms` }}>
            <Tarjeta className="flex h-full items-start justify-between gap-3 p-5 transition-[border-color,transform] duration-200 group-hover:-translate-y-0.5 group-hover:border-accent/60 animate-entrar">
              <div>
                <m.icono className="mb-3 size-5 text-accent" aria-hidden />
                <p className="font-display text-[20px] leading-tight">{m.etiqueta}</p>
              </div>
              <ArrowUpRight className="size-4 text-foreground-muted transition-colors group-hover:text-accent" aria-hidden />
            </Tarjeta>
          </Link>
        ))}
      </div>
    </ModuleLayout>
  );
}
